import {
  Button,
  PlusIcon,
  Text
} from 'stubben-edge-unified-frontend-react-components';
import { CAMPAIGN_CREATE_URL } from '../constants';

function CampaignsEmptyState() {
  return (
    <div
      className="flex flex-col items-center justify-center gap-4 rounded-xl bg-gray-100 py-12"
      data-cy="campaigns-empty-state"
    >
      <Text size="sm" variant="quaternary">
        No campaigns yet
      </Text>
      <Button
        href={CAMPAIGN_CREATE_URL}
        variant="secondary"
        className="!bg-white"
        leftSlot={<PlusIcon size={20} />}
        data-cy="create-campaign-empty-cta"
        testIdentifier="campaigns-page-empty-create-campaign"
      >
        Create campaign
      </Button>
    </div>
  );
}

export default CampaignsEmptyState;
